import { useMutation } from '@apollo/client';

import {
  ReopenBillPaymentMutation,
  ReopenBillPaymentMutationVariables,
} from '../graphql/generated';
import { REOPEN_PAYMENT } from '../graphql/mutations';

const useReopenPayment = () => {
  const [reopenPayment, result] = useMutation<
    ReopenBillPaymentMutation,
    ReopenBillPaymentMutationVariables
  >(REOPEN_PAYMENT);

  return {
    reopenPayment,
    ...result,
  };
};

export default useReopenPayment;
